import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import DisplayBox from "components/DisplayBox";
import Tags from "components/Tags";

/**
 * OrganizationDomain
 *
 * @param {Object}  data     Organization data
 * @param {Boolean} loading
 */
const OrganizationDomain = ({ data, loading, ...props }) => (
  <DisplayBox
    title={<FormattedMessage id="Organizations.OrganizationDomain.Title" />}
    description={<FormattedMessage id="Organizations.OrganizationDomain.Description" />}
    data={DOMAIN_DATA(data)}
    loading={loading}
    {...props}
  />
);

const DOMAIN_DATA = (data) => [
  {
    body: <Tags data={[{ name: data?.domain?.name }]} />,
  },
];

OrganizationDomain.propTypes = {
  data: PropTypes.shape({
    domain: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  loading: PropTypes.bool,
};

export default OrganizationDomain;
